export default "__VITE_ASSET__BcSTQOKA__"